import Vue from 'vue';
import gql from 'graphql-tag';

import createGraphQLClient from '@utils/graphql';

let graphqlClient = null

export const state = {
    objects: {},
}

export const getters = {}

export const mutations = {
  SET_MESSAGES(state,objects){
    let updatedObjects = {}
    for (let key in objects) {
        if (!objects[key].deleted_at) {
            // Remove the '__typename' field that gets added by GraphQL
            delete objects[key].__typename
            // Stage the update so we can just do one Vue.set
            updatedObjects[key] = objects[key]
        } else if (state.objects.hasOwnProperty(objects[key].id)) {
            // Immediately delete the object
            Vue.delete(state.objects, objects[key].id)
        }
    }
    state.objects = {
        ...updatedObjects,
    }
  }
}

export const actions = {
  init({ commit, rootState }){
    graphqlClient = createGraphQLClient(rootState)
  },
  async getMessages({ commit }){
    try {
      const response = await
          graphqlClient.query({
              query: gql`
              query{
                  messages {
                    id
                    body
                    to_number
                    from_number
                    client {
                      id
                      client_name
                      mobile
                    }
                    created_at
                  }
                }
              `,
            })
            graphqlClient.cache.reset()
            // console.log(response.data)
            commit('SET_MESSAGES', response.data.messages)
  } catch(ex){
    // console.log(ex)
    throw(ex)
  }
}
}
